import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-consulta-informacion',
  templateUrl: './consulta-informacion.component.html',
  styleUrls: ['./consulta-informacion.component.css']
})
export class ConsultaInformacionComponent implements OnInit {

  @Input() numeroDocumento: string = '';
  @Output() consultar = new EventEmitter<string>();

  // Variable booleana
  // isConsultarClicked: boolean = false;
  error: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  onConsultar(): void {
    // Validación
    if (!this.numeroDocumento || this.numeroDocumento.trim() === '') {
      this.error = true;
      return;
    }

    this.error = false;

    // this.isConsultarClicked = true;
    this.consultar.emit(this.numeroDocumento);
  }
}
